var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-field',{attrs:{"value":_vm.value,"options":_vm.items,"loading":_vm.loading,"disabled":_vm.disabled,"required":_vm.required,"errors":_vm.errors,"name":_vm.name,"label":_vm.labels.label,"placeholder":_vm.labels.placeholder,"size":"mini","value-key":"id","label-key":"name","as-key":_vm.asKey},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }